import { create } from 'zustand'

interface Actions {
    setNumberOfUnreadNotifications: (value: number) => void
}

interface State {
    numberOfUnreadNotifications: number
}

const initialState: State = {
    numberOfUnreadNotifications: 0,
}

export const useNotificationsStore = create<State & Actions>()((set, get) => ({
    ...initialState,
    setNumberOfUnreadNotifications: (value) => {
        set({
            numberOfUnreadNotifications: value,
        })
    },
}))
